import { createAction } from 'redux-actions-helpers'
import { ContestType, WorkItemType } from './types'

export const fetchContest = createAction(
  '@@profile-contests/FETCH_CONTEST',
  (id: string): any => ({ id })
)

export const fetchContestSuccess = createAction(
  '@@profile-contests/FETCH_CONTEST_SUCCESS',
  (result: ContestType | null): any => ({ result })
)

export const fetchContestFailure = createAction(
  '@@profile-contests/FETCH_CONTEST_FAILURE',
  (error: string): any => ({ error })
)

export const fetchMyWorks = createAction(
  '@@profile-contests/FETCH_MY_WORKS',
  (contest_id: string): any => ({ contest_id })
)

export const fetchMyWorksSuccess = createAction(
  '@@profile-contests/FETCH_MY_WORKS_SUCCESS',
  (result: WorkItemType[]): any => ({ result })
)

export const fetchMyWorksFailure = createAction(
  '@@profile-contests/FETCH_MY_WORKS_FAILURE',
  (error: string): any => ({ error })
)

export const fetchWorks = createAction(
  '@@profile-contests/FETCH_WORKS',
  (contest_id: string): any => ({ contest_id })
)

export const fetchWorksSuccess = createAction(
  '@@profile-contests/FETCH_WORKS_SUCCESS',
  (result: WorkItemType[]): any => ({ result })
)

export const fetchWorksFailure = createAction(
  '@@profile-contests/FETCH_WORKS_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@profile-contests/DESTROY')
